<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <v-form class="pa-6" ref="form">
        <v-col cols="12" class="py-0" v-if="similarities && similarities.length > 0">
          <v-alert
            class="mb-8 d-block mt-3"
            style="max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
            color="yellow darken-4"
            icon="mdi-alert-box"
            type="warning"
            text
          >
            {{  $t('form.publication.similaritiesAdmin') }}
            <v-list light style="margin-left:-0.5em;">
              <v-list-item v-for="similarity in similarities" :key="similarity.id">
                <v-list-item-content>
                  <v-list-item-title dark>
                    <v-btn :to="'/manage/edit/publications/edit/' + similarity.id" target="_blank" outlined style="white-space: break-spaces;">{{ similarity.title }}</v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>
        <ReviewPublication :mod-op_id="modOp_id" :publication="publication" />
        <v-row>
          <v-col cols="12">
            <h3 class="mt-15 mb-0">
              {{ $t("title.articleData") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <h5>{{ $t("form.article.journal") }}</h5>
            <v-text-field
                v-if="journalSelected !== undefined"
              :value="journalSelected.title"
              :label="$t('form.article.journal')"
              return-object
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <h5>
              {{ $t("form.article.publication_status") }}
            </h5>
            <v-select
              outlined
              v-model="publication.article.publication_status"
              :label="$t('form.article.publication_status')"
              :items="publicationStatus"
              readonly
              item-value="value"
              item-text="text"
            />
          </v-col>
        </v-row>
        <h5>{{ $t("label.dates") }}</h5>
        <v-row>
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
              outlined
              v-model="publication.article.accepted_date"
              :label="$t('form.article.accepted_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
              outlined
              v-model="publication.article.online_publication_date"
              :label="$t('form.article.online_publication_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" class="py-0">
            <v-text-field
              outlined
              v-model="publication.article.final_publication_date"
              :label="$t('form.article.final_publication_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>{{ $t("form.article.journal_location") }}</h5>
        <v-row>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.article.journal_location.issue_number"
              :label="$t('form.article.issueNumber')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="py-0">
            <v-text-field
              v-model="publication.article.journal_location.volume"
              :label="$t('form.article.volume')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" lg="2" class="py-0">
            <v-text-field
              v-model="publication.article.journal_location.page_number"
              :label="$t('form.article.pageNumber')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" lg="2" class="py-0">
            <v-text-field
              v-model="publication.article.journal_location.pages"
              :label="$t('form.article.pages')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" lg="2" class="py-0">
            <v-text-field
              v-model="publication.article.num_pages"
              :label="$t('form.article.num_pages')"
              required
              readonly
              outlined
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.article.feder_acknowledgements") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-checkbox
              class="big"
              v-model="publication.article.feder_acknowledgements"
              :label="$t('form.federAcknowledgementsDetail')"
              readonly
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <DirectorActions v-if="isAuthorize" :object_type="object_type" class="mt-6"/>
    <SupervisorActions
      v-else
      :item="publication"
      :object_type="object_type"
      :form_name="form_name"
      :state="state"
      :supervisor="supervisor !== null ? supervisor.username : ''"
      @change-state-supervisor="onStateSupervisorChange"
      class="mt-6"
    />
  </div>
</template>

<script>
import axios from "axios";
import changeState from "../../../mixins/changeState";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ReviewPublication from "./ReviewPublication";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  mixins: [changeState, publication_model],
  components: {
    ReviewPublication,
    SupervisorActions,
    DirectorActions
  },

  props:{
    similarities: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    form_name: "newArticleForm",
    menu: false,
    state: "",
    title: "",
    supervisor: "",
    object_id: null,
    object_type: "publication",
    journalSelected: "",
    modOp_id: null,
    publication: {
      title: "",
      abstract: "",
      keywords: "",
      doi: "",
      isbn: "",
      links: "",
      authors: [],
      authors_text: "",
      article: {
        journal_location: ""
      }
    }
  }),

  created() {
    this.getPublicationStatus();
    this.getJournals();
    this.getPublication();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  watch: {
    journals(){
      this.loadJournalSelected(this.publication.article.journal)
    }
  },

  methods: {
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.supervisor = response.data.supervisor;
          this.title = response.data.title;
          this.loadJournalSelected(this.publication.article.journal);
          if(["vd","pv","pa"].includes(this.state.toLowerCase()) ){
            axios({ url: this.$store.state.endpoint + "/similar/publication", method: "GET", params: { search: this.publication.title } })
            .then(resp => {
              this.similarities = resp.data;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadJournalSelected(item) {
      if (typeof item == "number") {
        this.journalSelected = this.journals.find(
          journal => journal.id === item
        );
      } else {
        this.journalSelected = item;
      }
    },
    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
